<div [class]="getClassName()">
  <cms-blog-new *ngFor='let new of news' [location]="location" [columns]="columns" [new]="new" [postLink]='postlink'></cms-blog-new>
</div>
